import { goodVibeCardFr, goodVibeDetailDialogFr } from "@domains/good-vibes/client/i18n/fr.ts";
import type { en } from "./en.ts";

export const fr: typeof en = {
    CreateMenu: {
        newGoodVibe: "Nouvelle Bonne Vibe",
        newFeedback: "Nouveau feedback"
    },
    Navigation: {
        home: {
            label: "Accueil",
            description: "Votre point quotidien"
        },
        "manager-impact": {
            label: "Mon impact en tant que gestionnaire"
        }
    },
    HomePage: {
        title: "Accueil",
        error: "Nous n'avons pas pu charger votre tableau de bord pour le moment.",
        liveRegion: {
            loading: "Chargement…"
        }
    },
    Errors: {
        retry: "Réessayer",
        retrying: "Nouvel essai…",
        reassurance: "Veuillez réessayer plus tard.",
        refreshBanner: "Impossible d'actualiser — affichage des derniers résultats."
    },
    HomeBriefCard: {
        title: "Bilan hebdomadaire",
        weekOf: "Semaine du {{date}}",
        older: "Afficher le bilan précédent",
        newer: "Afficher le bilan suivant",
        doneThatWeek_one: "{{done}} sur {{count}} terminé cette semaine-là",
        doneThatWeek_other: "{{done}} sur {{count}} terminés cette semaine-là",
        pastWeek: "Semaine passée",
        noBrief: "Pas encore de bilan hebdomadaire",
        worthKnowing: "Bon à savoir",
        runtime: {
            feedbackUnread_zero: "Lisez vos nouveaux feedbacks",
            feedbackUnread_one: "Lisez {{count}} nouveau feedback",
            feedbackUnread_other: "Lisez {{count}} nouveaux feedbacks",
            goodVibes_zero: "Ouvrez vos nouvelles Bonnes Vibes",
            goodVibes_one: "Ouvrez {{count}} nouvelle Bonne Vibe",
            goodVibes_other: "Ouvrez {{count}} nouvelles Bonnes Vibes",
            goalUpdates_zero: "Revoyez vos mises à jour d'objectifs cette semaine",
            goalUpdates_one: "Revoyez {{count}} mise à jour d'objectif cette semaine",
            goalUpdates_other: "Revoyez {{count}} mises à jour d'objectifs cette semaine",
            selfReview: "Rédigez votre auto-évaluation",
            reviews_zero: "Rédigez vos évaluations",
            reviews_one: "Rédigez {{count}} évaluation",
            reviews_other: "Rédigez {{count}} évaluations",
            moreReviews_one: "{{count}} autre évaluation à rédiger",
            moreReviews_other: "{{count}} autres évaluations à rédiger"
        },
        draft: {
            sent: "Envoyé",
            completeError: "Envoyé, mais nous n'avons pas pu le marquer comme fait dans votre liste."
        },
        cta: {
            prompt: {
                addToAgenda: "Ajoute ceci à l'agenda du 1:1 concerné : {{title}}",
                prepTalkingPoints: "Prépare mes points à aborder pour cet élément de mon bilan hebdomadaire : {{title}}",
                bookMeeting: "Planifie une rencontre pour cet élément de mon bilan hebdomadaire : {{title}}",
                followUp: "Fais le suivi de ces éléments d'action : {{title}}",
                draftGoodVibe: "Rédige une Bonne Vibe pour cet élément de mon bilan hebdomadaire : {{title}}",
                replyFeedback: "Rédige une réponse à ce feedback de mon bilan hebdomadaire : {{title}}",
                draftReply: "Rédige ma réponse Slack pour cet élément de mon bilan hebdomadaire : {{title}}"
            }
        },
        personalize: "Personnaliser votre bilan",
        loading: "Chargement de votre bilan hebdomadaire",
        error: "Nous n'avons pas pu charger votre bilan hebdomadaire.",
        retry: "Réessayer",
        generating: "Préparation du bilan de la semaine. Cela peut prendre quelques minutes.",
        generationError: "Nous n'avons pas pu préparer votre bilan hebdomadaire.",
        writeError: "Nous n'avons pas pu enregistrer ce changement. Réessayez.",
        clearError: "Nous n'avons pas pu effacer les éléments terminés. Réessayez.",
        refresh: {
            label: "Actualiser votre bilan",
            title: "Actualiser",
            running: "Actualisation de votre bilan",
            done: "Votre bilan est à jour",
            error: "Nous n'avons pas pu actualiser votre bilan. Votre bilan actuel est inchangé.",
            lastUpdated: "Dernière mise à jour : {{time}}"
        }
    },
    HomeBriefList: {
        due: {
            late_one: "{{count}} j de retard",
            late_other: "{{count}} j de retard",
            today: "Aujourd'hui",
            thisWeek: "Cette semaine"
        },
        dueSpoken: {
            late_one: "{{count}} jour de retard",
            late_other: "{{count}} jours de retard",
            today: "Échéance aujourd'hui",
            thisWeek: "Échéance cette semaine",
            on: "Échéance le {{date}}"
        },
        markDone: "Marquer « {{title}} » comme terminé",
        doneWhenRead: "« {{title}} » est terminé quand vous avez tout lu",
        needsAttention: "Demande votre attention",
        looksDone: "Semble terminé",
        clear: {
            title: "Rien ne vous attend cette semaine",
            allDone_one: "Votre seul élément est terminé",
            allDone_other: "Les {{count}} éléments sont terminés cette semaine",
            subtitle: "Ce qui demande votre attention apparaîtra ici."
        },
        state: {
            done: "Terminé",
            open: "Non terminé"
        },
        showMore: "Afficher plus",
        showLess: "Afficher moins",
        clearDone: "Effacer les terminés",
        seeAllActionItems: "Voir tous les éléments d'action"
    },
    BriefActions: {
        bookMeeting: "Planifier une rencontre",
        sendGoodVibe: "Envoyer une Bonne Vibe",
        reply: "Répondre",
        sendMessage: "Envoyer le message",
        addToAgenda: "Ajouter à l'agenda",
        prepTalkingPoints: "Préparer mes points",
        followUp: "Faire un suivi",
        reviewGoodVibe: "Revoir la Bonne Vibe",
        reviewReply: "Revoir la réponse",
        reviewMessage: "Revoir le message",
        read: "Lire",
        connect: "Connecter {{app}}",
        connectCalendar: "Connecter le calendrier",
        connectWhy: {
            gitHub: "Connectez GitHub pour voir la demande de tirage, ses vérifications et ses revues.",
            jira: "Connectez Jira pour voir le billet et où il en est.",
            confluence: "Connectez Confluence pour voir la page et ce qui y a changé.",
            slack: "Connectez Slack pour voir tout le fil de discussion.",
            google: "Connectez Google pour voir le document et ses dernières modifications.",
            sharePoint: "Connectez SharePoint pour voir le document et ses dernières modifications."
        },
        opensInNewTab: "s'ouvre dans un nouvel onglet"
    },
    BriefGoodVibesDialog: {
        title: "Nouvelles Bonnes Vibes",
        loading: "Chargement des Bonnes Vibes",
        error: "Impossible de charger vos Bonnes Vibes.",
        viewer: {
            title: "Les vôtres",
            seeAll: "Voir toutes vos Bonnes Vibes"
        },
        team: {
            title: "Votre équipe",
            seeAll: "Voir les Bonnes Vibes de votre équipe"
        },
        more: "Voir toutes les Bonnes Vibes",
        empty: "Rien de nouveau",
        sealed: {
            badge: "Nouvelles Bonnes Vibes",
            pressAndHold: "Maintenir enfoncé pour ouvrir",
            ariaLabel: "Une nouvelle Bonne Vibe pour {{recipients}} — maintenez enfoncé pour ouvrir"
        },
        addCommentError: "Une erreur est survenue lors de la publication de votre réponse. Veuillez réessayer.",
        editCommentSuccess: "Réponse mise à jour",
        editCommentError: "Une erreur est survenue lors de la mise à jour de votre réponse. Veuillez réessayer.",
        deleteCommentSuccess: "Réponse supprimée",
        deleteCommentError: "Une erreur est survenue lors de la suppression de votre réponse. Veuillez réessayer."
    },
    GoodVibesCard: { ...goodVibeCardFr },
    GoodVibesDetailDialog: { ...goodVibeDetailDialogFr },
    HomeAgentPanel: {
        greeting: {
            morning: "👋 Bonjour, {{name}}.",
            afternoon: "👋 Bon après-midi, {{name}}.",
            evening: "👋 Bonsoir, {{name}}."
        },
        briefGreeting: {
            morning: "☕\u00a0 Bonjour, {{name}}",
            afternoon: "☀️\u00a0 Bon après-midi, {{name}}",
            evening: "🌙\u00a0 Bonsoir, {{name}}",
            night: "🌙\u00a0 Bonne nuit, {{name}}"
        },
        inputLabel: "Posez une question à votre agent",
        inputPlaceholder: "Demandez n'importe quoi sur votre équipe ou votre entreprise",
        sendLabel: "Envoyer à votre agent",
        quickPrompts: {
            teamDoing: "Comment va mon équipe?",
            worthAttention: "Qu'est-ce qui mérite mon attention?",
            whoToRecognize: "Qui devrais-je reconnaître cette semaine?"
        }
    },
    HomePerformanceCard: {
        badge: "Cycle d'évaluation actif",
        empty: "Aucun cycle d'évaluation actif",
        opensInNewTab: "S'ouvre dans un nouvel onglet",
        rows: {
            selfReview: "Autoévaluations",
            managerReview: "Gestionnaire",
            peerReview: "Pairs",
            upwardReview: "Ascendantes"
        }
    },
    HomePerformanceCarousel: {
        counter: "{{current}} sur {{total}}",
        previous: "Cycle précédent",
        next: "Cycle suivant"
    },
    HomeNewAndOutstanding: {
        heading: "Nouveautés et en attente",
        empty: "Vous êtes à jour — rien de nouveau pour votre équipe.",
        reviewsToWriteNoun_one: "évaluation à rédiger",
        reviewsToWriteNoun_other: "évaluations à rédiger",
        reviewsToWriteShowMore_one: "Afficher 1 de plus",
        reviewsToWriteShowMore_other: "Afficher {{count}} de plus",
        reviewsToWriteShowLess: "Afficher moins",
        reviewerAssignmentsNoun_one: "désignation d'évaluateurs à faire",
        reviewerAssignmentsNoun_other: "désignations d'évaluateurs à faire",
        assignment: {
            peer: "Désigner les pairs qui évalueront {{name}}",
            upward: "Désigner les évaluateurs ascendants pour {{name}}",
            peerDue: "Évaluation par les pairs due le {{date}}",
            upwardDue: "Évaluation ascendante due le {{date}}"
        },
        review: {
            self: "Votre autoévaluation",
            managerOf: "Évaluation du gestionnaire de {{name}}",
            peerOf: "Évaluation par les pairs de {{name}}",
            upwardOf: "Évaluation ascendante de {{name}}",
            due: "Échéance {{date}}"
        },
        badges: {
            unreadFeedback: "feedback non lus",
            newGoodVibes_one: "nouvelle Bonne Vibe pour moi",
            newGoodVibes_other: "nouvelles Bonnes Vibes pour moi",
            unseenReportsGoodVibes_one: "Bonne Vibe non vue pour mes subordonnés",
            unseenReportsGoodVibes_other: "Bonnes Vibes non vues pour mes subordonnés",
            goalUpdates: "mises à jour d'objectifs récentes"
        }
    },
    HomeMyTeam: {
        heading: "Mon équipe",
        empty: "Aucun membre d'équipe",
        actions: {
            label: "Actions pour {{name}}",
            sendGoodVibes: "Envoyer des Bonnes Vibes",
            openNextOneOnOne: "Ouvrir le prochain 1:1"
        },
        scope: {
            ariaLabel: "Portée des subordonnés",
            allReports: "Tous les subordonnés",
            directReports: "Subordonnés directs"
        },
        emptyDirect: "Aucun subordonné direct"
    },
    HomeBringYourTeamIn: {
        heading: "Intégrez votre équipe",
        description: "Synchronisez à partir de votre SIRH, Slack, Microsoft ou Google pour garder votre équipe à jour. Vous choisissez qui est synchronisé.",
        connectHris: "Connecter votre SIRH",
        addManually: "Ou ajoutez des personnes manuellement",
        uploadSpreadsheet: "Téléverser un tableur",
        invitePeople: "Inviter des personnes",
        modalBody: "La mise en place de votre équipe se fait pour l'instant dans Workleap Classic. Nous allons vous y amener. Rien ne sera perdu."
    },
    ManagerImpactReportPage: {
        title: "Mon impact en tant que gestionnaire",
        subtitle: "Comment vous impactez vos subordonnés directs.",
        betaBadge: "Bêta",
        breadcrumb: {
            ariaLabel: "Fil d'Ariane",
            home: "Accueil"
        },
        howToImprove: "Comment m'améliorer",
        empty: "Votre rapport n'est pas encore prêt. Revenez bientôt.",
        pillars: {
            heading: "Deux piliers",
            subtitle: "Votre score global combine Pratique (60 %) et Résultat (40 %)."
        },
        improveScorePrompt: "Comment puis-je améliorer mon score `{{scoreName}}` ? Donne-moi des actions précises que je peux faire cette semaine.",
        howToImprovePrompt: "Comment puis-je améliorer mon impact en tant que gestionnaire ? Dis-moi sur quoi me concentrer.",
        liveRegion: {
            loading: "Chargement…"
        },
        feedback: {
            heading: "Comment est ce rapport ?",
            description: "Ce rapport est nouveau et encore en bêta. Un retour rapide de votre part influence ce que nous livrons.",
            accurate: "Ce rapport est utile",
            inaccurate: "Ce rapport n'est pas utile",
            placeholder: "Quelque chose à changer ? Optionnel.",
            submit: "Envoyer le retour",
            thanks: "Merci, nous avons enregistré votre retour."
        }
    },
    ManagerImpactOverallScoreCard: {
        heading: "Mon dernier score de gestion",
        outOf: "/ {{max}}",
        status: {
            great: "Excellent",
            needsWork: "À améliorer",
            noData: "Pas encore assez de données"
        }
    },
    ManagerImpactPillarCard: {
        practice: {
            title: "Pratique",
            description: "Ce que vous contrôlez. Travaillez sur ceux-ci maintenant — ils améliorent votre score immédiatement."
        },
        outcome: {
            title: "Résultat",
            description: "Ce qui suit. Il n'évolue que lorsque votre pratique se maintient dans le temps."
        },
        outOf: "/ {{max}}",
        composedOf: "Composé de",
        list: {
            ariaLabel: "Signaux composant votre score {{pillar}}"
        },
        status: {
            noData: "Pas encore assez de données"
        }
    },
    ManagerImpactComposingScoreRow: {
        status: {
            great: "Excellent",
            needsWork: "À améliorer",
            noData: "Pas encore assez de données"
        },
        improveThisScore: "Obtenir des suggestions",
        signals: {
            "reply-rate-from-feedback": "Taux de réponse aux feedback",
            "response-time-from-feedback": "Temps de réponse aux feedback",
            "review-submission-rate": "Taux de soumission des évaluations",
            "goals-updated-hygiene": "Fréquence de mise à jour des objectifs",
            "recognition-sent": "Reconnaissance donnée",
            "my-review-score": "Mon score d'évaluation",
            "overall-review-score": "Score d'évaluation global",
            "enps-from-pulse": "eNPS de Pulse",
            "goal-attainment": "Atteinte des objectifs",
            "relationship-with-manager": "Relation avec le gestionnaire"
        },
        descriptions: {
            "reply-rate-from-feedback": "Le nombre de feedbacks et de messages de vos subordonnés directs auxquels vous avez répondu au cours du dernier mois.",
            "response-time-from-feedback": "Le temps moyen que vous avez pris pour répondre aux feedbacks de vos subordonnés directs au cours du dernier mois.",
            "review-submission-rate": "La part de vos subordonnés directs pour qui vous avez soumis à temps la dernière évaluation due.",
            "goals-updated-hygiene": "La part de vos objectifs d'équipe et de ceux de vos subordonnés directs qui sont maintenus à jour.",
            "recognition-sent": "Le nombre de vos subordonnés directs que vous avez reconnus au cours du dernier mois.",
            "my-review-score": "Votre propre score d'évaluation — la note que vous a donnée votre gestionnaire immédiat (la personne dont vous relevez). Nous considérons ce score excellent lorsqu'il atteint 70 % de l'échelle d'évaluation (pour une échelle sur 5, 3.5 sur 5).",
            "overall-review-score": "Le score moyen des dernières évaluations de performance complétées de vos subordonnés directs. Nous considérons ce score excellent lorsqu'il atteint 70 % de l'échelle d'évaluation (pour une échelle sur 5, 3.5 sur 5).",
            "enps-from-pulse": "La probabilité que vos subordonnés directs recommandent l'entreprise comme lieu de travail.",
            "goal-attainment": "La part des objectifs atteints, parmi ceux dont vous ou vos subordonnés directs êtes propriétaires.",
            "relationship-with-manager": "Le score de relation avec le gestionnaire de vos subordonnés directs, selon Pulse."
        }
    },
    ManagerImpactSignalInfo: {
        label: "À propos de {{signal}}"
    },
    ManagerImpactLowConfidenceFlag: {
        label: "Confiance faible — participation limitée au sondage"
    },
    HomeManagerImpactTile: {
        title: "Mon impact en tant que gestionnaire",
        new: "Nouveau",
        seeReport: "Voir le rapport",
        liveRegion: {
            loading: "Chargement de votre rapport d'impact"
        },
        insight: {
            improve: "Vous pouvez progresser en tant que gestionnaire en travaillant sur {{opportunityLabel}}.",
            praise: "Vous êtes un excellent gestionnaire. Pour aller encore plus loin, concentrez-vous sur {{opportunityLabel}}.",
            empty: "Nous recueillons encore des données sur vos subordonnés directs."
        },
        opportunityLabels: {
            "reply-rate-from-feedback": "votre taux de réponse aux feedback",
            "response-time-from-feedback": "la rapidité de vos réponses aux feedback",
            "review-submission-rate": "votre taux de soumission des évaluations",
            "goals-updated-hygiene": "la fréquence de mise à jour de vos objectifs",
            "recognition-sent": "la reconnaissance que vous accordez à vos subordonnés directs",
            "my-review-score": "votre propre score d'évaluation",
            "overall-review-score": "le score d'évaluation de vos subordonnés directs",
            "enps-from-pulse": "l'eNPS de vos subordonnés directs",
            "goal-attainment": "l'atteinte des objectifs de vos subordonnés directs",
            "relationship-with-manager": "la relation de vos subordonnés directs avec vous"
        }
    },
    HomeManagerImpactCard: {
        liveRegion: {
            loading: "Chargement de votre rapport d'impact"
        },
        eyebrow: "Nouveau rapport",
        cta: "Mon rapport d'impact",
        insight: {
            improve: "Vous pouvez progresser en tant que gestionnaire en travaillant sur {{opportunityLabel}}. Consultez votre rapport pour voir comment.",
            praise: "Vous êtes un excellent gestionnaire. Pour aller encore plus loin, concentrez-vous sur {{opportunityLabel}}.",
            empty: "Nous recueillons encore des données sur vos subordonnés directs. Consultez votre rapport pour voir ce qui est suivi."
        },
        opportunityLabels: {
            "reply-rate-from-feedback": "votre taux de réponse aux feedback",
            "response-time-from-feedback": "la rapidité de vos réponses aux feedback",
            "review-submission-rate": "votre taux de soumission des évaluations",
            "goals-updated-hygiene": "la fréquence de mise à jour de vos objectifs",
            "recognition-sent": "la reconnaissance que vous accordez à vos subordonnés directs",
            "my-review-score": "votre propre score d'évaluation",
            "overall-review-score": "le score d'évaluation de vos subordonnés directs",
            "enps-from-pulse": "l'eNPS de vos subordonnés directs",
            "goal-attainment": "l'atteinte des objectifs de vos subordonnés directs",
            "relationship-with-manager": "la relation de vos subordonnés directs avec vous"
        }
    }
};
